import { render, staticRenderFns } from "./PrintBillA4.vue?vue&type=template&id=98e19506&"
import script from "./PrintBillA4.vue?vue&type=script&lang=js&"
export * from "./PrintBillA4.vue?vue&type=script&lang=js&"
import style0 from "./PrintBillA4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports